import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visao',
  templateUrl: './visao.component.html',
  styleUrls: ['./visao.component.css']
})
export class VisaoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
